"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.required = exports.requiredDescriptionForOtherValue = exports.hasOtherValue = exports.requiredDurationValidator = exports.requiredNumberValidator = exports.requiredValidator = exports.uniqueRecordFieldValue = exports.uniqueRecordFieldValueWithContext = exports.dummyValidator = exports.requiredIpList = exports.ipAddressField = exports.maxItems = exports.maxItemLength = exports.checklistRequired = exports.colorFieldValidator = exports.requiredSocialNetwork = exports.requiredTimeTrackingField = exports.requiredDateRange = exports.requiredRefField = exports.requiredDoc = exports.requiredList = exports.linkField = exports.requiredSignature = exports.requiredAddressField = exports.requiredAddressSingleValidator = exports.requiredPhoneList = exports.phoneField = exports.dueDateRequired = exports.requiredDueDateValidator = exports.emailField = exports.emailValidator = exports.requiredFullNameField = exports.requiredStatusField = exports.requiredStatusFieldValidator = exports.requiredDate = exports.validateRequiredDateValue = exports.numberBetweenMinMaxValue = exports.integerNumberField = exports.numberField = exports.requiredNumber = void 0;
const helpers_1 = require("@smartsuite/smartdoc/lib/esm/core/helpers");
const libphonenumber_js_1 = require("libphonenumber-js");
const types_1 = require("@smartsuite/types");
const fields_1 = require("../utils/fields");
const intl_1 = require("../locale/intl");
const texts_1 = require("../texts");
const number_1 = require("../utils/number");
const email_validation_1 = require("@smartsuite/email-validation");
const comparisons_1 = require("../comparisons/comparisons");
const link_1 = require("../utils/link");
const object_1 = require("../utils/object");
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
const requiredNumber = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    const validator = getRequiredNumberValidator(field.field_type);
    return {
        validator: isRequired ? validator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredNumber = requiredNumber;
const getRequiredNumberValidator = (fieldType) => {
    if (["numberfield", "percentfield", "rollupfield", "countfield"].includes(fieldType)) {
        return exports.requiredNumberValidator;
    }
    if (fieldType === "durationfield") {
        return exports.requiredDurationValidator;
    }
    return exports.requiredValidator;
};
const baseNumberField = (field, precision) => {
    const regex = (0, number_1.getNumberRegex)(precision, field.params.allow_negative);
    const validator = (value) => !value || regex.test(String(value)) ? null : { numberField: true };
    return {
        validator,
        message: (0, intl_1.$t)(texts_1.validationText.please_enter_correct_number),
    };
};
const numberField = (field) => {
    var _a;
    // This is a temporary fix to allow free editing of the specified fields.
    const precision = [
        "currencyfield",
        "percentfield",
        "numberfield",
        "rollupfield",
        "formulafield",
    ].includes(field.field_type)
        ? types_1.MAX_PRECISION
        : ((_a = field.params.precision) !== null && _a !== void 0 ? _a : 0) || 0;
    return baseNumberField(field, precision);
};
exports.numberField = numberField;
const integerNumberField = (field) => {
    return baseNumberField(field, 0);
};
exports.integerNumberField = integerNumberField;
const numberBetweenMinMaxValue = (field) => {
    const minValue = (0, fields_1.getFieldParamValue)(field, "min_value");
    const maxValue = (0, fields_1.getFieldParamValue)(field, "max_value");
    const validator = (value) => !value || (value >= minValue && value <= maxValue)
        ? null
        : { numberBetweenMinMaxValue: true };
    return {
        validator: maxValue ? validator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.validationText.value_must_be_between, {
            minValue,
            maxValue,
        }),
    };
};
exports.numberBetweenMinMaxValue = numberBetweenMinMaxValue;
const validateRequiredDateValue = (value) => {
    return !(value === null || value === void 0 ? void 0 : value.date) ? { requiredDate: true } : null;
};
exports.validateRequiredDateValue = validateRequiredDateValue;
const requiredDate = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? exports.validateRequiredDateValue : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredDate = requiredDate;
const requiredStatusFieldValidator = (value) => {
    return !(value === null || value === void 0 ? void 0 : value.value) ? { required: true } : null;
};
exports.requiredStatusFieldValidator = requiredStatusFieldValidator;
const requiredStatusField = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? exports.requiredStatusFieldValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.validationText.value_is_required),
    };
};
exports.requiredStatusField = requiredStatusField;
const requiredFullNameField = (field) => {
    const { required, display_fields: displayFields } = field.params;
    const validator = (fullName) => {
        if (!required) {
            return null;
        }
        if (!fullName) {
            return { required: true };
        }
        const isTitleEmpty = !!(displayFields === null || displayFields === void 0 ? void 0 : displayFields.includes("title")) && !fullName.title;
        const isFirstNameEmpty = !fullName.first_name.trim();
        const isLastNameEmpty = !fullName.last_name.trim();
        const isEmpty = isTitleEmpty || isFirstNameEmpty || isLastNameEmpty;
        return isEmpty ? { required: true } : null;
    };
    return {
        validator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredFullNameField = requiredFullNameField;
const emailValidator = (value) => {
    if (!value || !Array.isArray(value)) {
        return null;
    }
    return value.every((email) => (0, email_validation_1.validateEmailAddress)(email))
        ? null
        : { emailField: true };
};
exports.emailValidator = emailValidator;
const emailField = () => {
    return {
        validator: exports.emailValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.enter_a_valid_email_address),
    };
};
exports.emailField = emailField;
const requiredDueDateValidator = (value) => {
    var _a;
    const empty = !((_a = value === null || value === void 0 ? void 0 : value.to_date) === null || _a === void 0 ? void 0 : _a.date);
    return empty ? { required: true } : null;
};
exports.requiredDueDateValidator = requiredDueDateValidator;
const dueDateRequired = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? exports.requiredDueDateValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.dueDateRequired = dueDateRequired;
const phoneArrayValidator = (value) => {
    if (!value || !Array.isArray(value)) {
        return null;
    }
    return value.every((item) => {
        var _a, _b;
        if (!item.phone_number) {
            return false;
        }
        const phoneNumber = (0, libphonenumber_js_1.parsePhoneNumberFromString)(item.phone_number, item.phone_country);
        if (!phoneNumber && item.phone_number) {
            return false;
        }
        if (((_a = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.country) === null || _a === void 0 ? void 0 : _a.toLowerCase().trim()) !==
            ((_b = item.phone_country) === null || _b === void 0 ? void 0 : _b.toLowerCase().trim())) {
            return false;
        }
        return phoneNumber ? phoneNumber.isValid() : true;
    })
        ? null
        : { phoneField: true };
};
const phoneField = () => {
    return {
        validator: phoneArrayValidator,
        message: (0, intl_1.$t)(texts_1.validationText.phone_number),
    };
};
exports.phoneField = phoneField;
const requiredPhoneListValidator = (value) => {
    if (!value) {
        return null;
    }
    const isValid = value.length > 0 && value.every((phone) => !!phone.phone_number);
    return !isValid ? { requiredPhoneList: true } : null;
};
const requiredPhoneList = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? requiredPhoneListValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredPhoneList = requiredPhoneList;
const requiredAddressSingleValidator = (value) => {
    const isEmpty = Object.values(value).every((val) => !(val === null || val === void 0 ? void 0 : val.trim()));
    return isEmpty ? { required: true } : null;
};
exports.requiredAddressSingleValidator = requiredAddressSingleValidator;
const requiredAddressMultipleValidator = (value) => {
    var _a, _b;
    const isEmpty = !((_a = value === null || value === void 0 ? void 0 : value.location_address) === null || _a === void 0 ? void 0 : _a.trim()) && !((_b = value === null || value === void 0 ? void 0 : value.location_city) === null || _b === void 0 ? void 0 : _b.trim());
    return isEmpty ? { required: true } : null;
};
const requiredAddressField = (field) => {
    // for the single-line address field, we only require one field - but it will be saved to the location_address field
    // for the multiple-line address field, we require at least location_address or location_city
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    const addressValidator = field.params.display_format === "single"
        ? exports.requiredAddressSingleValidator
        : requiredAddressMultipleValidator;
    return {
        validator: isRequired ? addressValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredAddressField = requiredAddressField;
const requiredSignatureValidator = (value) => {
    return !(0, comparisons_1.isSignatureHasValue)(value) ? { required: true } : null;
};
const requiredSignature = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? requiredSignatureValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredSignature = requiredSignature;
const linkField = () => {
    return {
        validator: linkValidator,
        message: (0, intl_1.$t)(texts_1.linkFieldText.enter_a_valid_url_address),
    };
};
exports.linkField = linkField;
const linkValidator = (value) => {
    if (!value || !Array.isArray(value)) {
        return null;
    }
    return value.every((link) => !link || (0, link_1.isUrlValid)(link))
        ? null
        : { linkField: true };
};
const requiredList = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? requiredListValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredList = requiredList;
const requiredListValidator = (value) => {
    if (!value) {
        return null;
    }
    const isValid = value.length > 0 && value.every((item) => !!item);
    return !isValid ? { requiredList: true } : null;
};
const requiredDoc = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    const validator = (value) => {
        if (!value) {
            return { required: true };
        }
        const data = value.data;
        if (!(data === null || data === void 0 ? void 0 : data.content)) {
            return { required: true };
        }
        return (0, helpers_1.isDocEmpty)(data) ? { required: true } : null;
    };
    return {
        validator: isRequired ? validator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredDoc = requiredDoc;
const requiredRefField = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? exports.requiredValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredRefField = requiredRefField;
const requiredDateRangeValidator = (value) => {
    var _a, _b;
    return !((_a = value === null || value === void 0 ? void 0 : value.from_date) === null || _a === void 0 ? void 0 : _a.date) || !((_b = value === null || value === void 0 ? void 0 : value.to_date) === null || _b === void 0 ? void 0 : _b.date)
        ? { requiredDateRange: true }
        : null;
};
const requiredDateRange = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? requiredDateRangeValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredDateRange = requiredDateRange;
const requiredTimeTrackingValidator = (value) => {
    var _a;
    const isEmpty = !((_a = value === null || value === void 0 ? void 0 : value.time_track_logs) === null || _a === void 0 ? void 0 : _a.length);
    return isEmpty ? { required: true } : null;
};
const requiredTimeTrackingField = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? requiredTimeTrackingValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredTimeTrackingField = requiredTimeTrackingField;
const requiredSocialNetwork = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    const validator = (value) => {
        var _a;
        if (!value) {
            return { required: true };
        }
        const params = (_a = field.params.choices) === null || _a === void 0 ? void 0 : _a.map((choice) => `${choice.label}_username`);
        let isEmpty = false;
        (0, object_1.getKeys)(value).forEach((element) => {
            if (value[element] === "" &&
                (params === null || params === void 0 ? void 0 : params.find((param) => param.toLowerCase() === element.toLowerCase()))) {
                isEmpty = true;
            }
        });
        return isEmpty ? { required: true } : null;
    };
    return {
        validator: isRequired ? validator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredSocialNetwork = requiredSocialNetwork;
const colorPickerValidator = (value) => {
    return (value || []).every((color) => (0, comparisons_1.isValidHexColor)(color.value))
        ? null
        : { colorField: true };
};
const colorFieldValidator = () => {
    return {
        validator: colorPickerValidator,
        message: (0, intl_1.$t)(texts_1.colorPickerFieldText.enter_a_valid_color),
    };
};
exports.colorFieldValidator = colorFieldValidator;
const checklistRequiredValidator = (value) => {
    var _a;
    const isEmpty = !((_a = value === null || value === void 0 ? void 0 : value.items) === null || _a === void 0 ? void 0 : _a.length);
    return isEmpty ? { required: true } : null;
};
const checklistItemMaxLengthValidator = (value) => {
    var _a;
    const items = (_a = value === null || value === void 0 ? void 0 : value.items) !== null && _a !== void 0 ? _a : [];
    const lessThanMax = items.every((item) => (0, helpers_1.getTextualLength)(item.content.data) <= types_1.checklistItemMaxLength);
    return lessThanMax ? null : { maxItemLength: true };
};
const checklistMaxNumItemsValidator = (value) => {
    var _a;
    const items = (_a = value === null || value === void 0 ? void 0 : value.items) !== null && _a !== void 0 ? _a : [];
    return items.length <= types_1.checklistMaxNumItems ? null : { maxItems: true };
};
const checklistRequired = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? checklistRequiredValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.checklistRequired = checklistRequired;
const maxItemLength = () => {
    return {
        validator: checklistItemMaxLengthValidator,
        message: (0, intl_1.$t)(texts_1.checklistFieldText.each_item_is_limited, {
            checklistItemMaxLength: types_1.checklistItemMaxLength,
        }),
    };
};
exports.maxItemLength = maxItemLength;
const maxItems = () => {
    return {
        validator: checklistMaxNumItemsValidator,
        message: (0, intl_1.$t)(texts_1.checklistFieldText.cannot_have_more, { checklistMaxNumItems: types_1.checklistMaxNumItems }),
    };
};
exports.maxItems = maxItems;
const ipAddressField = () => {
    return {
        validator: addressValidator,
        message: (0, intl_1.$t)(texts_1.ipAddressFieldText.enter_a_valid_ip_address),
    };
};
exports.ipAddressField = ipAddressField;
const addressValidator = (value) => {
    if (!value) {
        return null;
    }
    const regex = new RegExp(types_1.ipv4Ipv6Regex);
    return value.every((ipAddress) => !ipAddress.address || regex.test(ipAddress.address))
        ? null
        : { ipAddressField: true };
};
const requiredIpList = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? requiredIpAddressValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.requiredIpList = requiredIpList;
const requiredIpAddressValidator = (value) => {
    if ((value === null || value === void 0 ? void 0 : value.length) > 1) {
        return null;
    }
    const isInvalid = !(value === null || value === void 0 ? void 0 : value.length) || !value[0].address;
    return isInvalid ? { requiredIpList: true } : null;
};
const dummyValidator = () => null;
exports.dummyValidator = dummyValidator;
const uniqueRecordFieldValueWithContext = (context) => {
    const wrappedCreator = (field, records, record, applicationId) => (0, exports.uniqueRecordFieldValue)(field, records, record, applicationId, context);
    return wrappedCreator;
};
exports.uniqueRecordFieldValueWithContext = uniqueRecordFieldValueWithContext;
const uniqueRecordFieldValue = (field, records, record, applicationId, context) => {
    if (applicationId) {
        return asyncUniqueValidator(field, records, record, applicationId, context);
    }
    return syncUniqueValidator(field, records, record);
};
exports.uniqueRecordFieldValue = uniqueRecordFieldValue;
const asyncUniqueValidator = (field, records, record, applicationId, context) => {
    const unique = (0, fields_1.getFieldParamValue)(field, "unique");
    const validator = async (value) => {
        if (!unique || !value) {
            return null;
        }
        const syncValidator = syncUniqueValidator(field, records, record).validator;
        const syncError = syncValidator(value);
        if (syncError) {
            return await Promise.resolve(syncError);
        }
        if (!context) {
            return null;
        }
        return await context
            .checkUniqueness(applicationId, field.slug, value, record === null || record === void 0 ? void 0 : record.id)
            .toPromise()
            .then((isUnique) => {
            return isUnique ? null : { unique: false };
        });
    };
    validator.async = true;
    return {
        validator: unique ? validator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.value_should_be_unique, {
            fieldLabel: field.label,
        }),
    };
};
const syncUniqueValidator = (field, records, record) => {
    const unique = (0, fields_1.getFieldParamValue)(field, "unique");
    const validator = (value) => {
        if (!unique || !value) {
            return null;
        }
        let appRecords = records;
        if (record === null || record === void 0 ? void 0 : record.id) {
            appRecords = records === null || records === void 0 ? void 0 : records.filter(
            // eslint-disable-next-line @typescript-eslint/naming-convention
            ({ id, application_id }) => id !== record.id && application_id === record.application_id);
        }
        const isUnique = !(appRecords === null || appRecords === void 0 ? void 0 : appRecords.find((r) => isEqualIgnoringCase((0, fields_1.getValueFromRecordByField)(r, field), value)));
        return isUnique ? null : { unique: false };
    };
    return {
        validator: unique ? validator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.value_should_be_unique, {
            fieldLabel: field.label,
        }),
    };
};
const isArrayEqual = (a, b) => {
    // calculate empty array as not equal to any other one
    if (a.length !== b.length || a.length === 0 || b.length === 0) {
        return false;
    }
    return (a
        .map((item) => item.toString().toLowerCase())
        .sort()
        .toString() ===
        b
            .map((item) => item.toString().toLowerCase())
            .sort()
            .toString());
};
const isEqualIgnoringCase = (a, b) => {
    if (typeof a === "string" && typeof b === "string") {
        return a.toLowerCase() === b.toLowerCase();
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        return isArrayEqual(a, b);
    }
    return a === b;
};
const requiredValidator = (value) => {
    const falsyValue = !value;
    const emptyArray = value instanceof Array && value.length === 0;
    const emptyTrimmedString = typeof value === "string" && value.trim() === "";
    const isEmpty = falsyValue || emptyArray || emptyTrimmedString;
    return isEmpty ? { required: true } : null;
};
exports.requiredValidator = requiredValidator;
const requiredNumberValidator = (value) => {
    const isEmptyValue = value === null || value === undefined;
    const isNotNumberValue = typeof value !== "number";
    const isEmpty = isEmptyValue || isNotNumberValue;
    return isEmpty ? { required: true } : null;
};
exports.requiredNumberValidator = requiredNumberValidator;
const requiredDurationValidator = (value) => {
    const isEmptyValue = value === null || value === undefined;
    const isConvertibleToNumber = typeof value === "number" ||
        (typeof value === "string" && !isNaN(Number(value)) && value.trim() !== "");
    const isEmpty = isEmptyValue || !isConvertibleToNumber;
    return isEmpty ? { required: true } : null;
};
exports.requiredDurationValidator = requiredDurationValidator;
/**
 * Checks if the value contains an "OTHER_VALUE" option
 */
const hasOtherValue = (value) => {
    if (typeof value === "string") {
        return value === "OTHER_VALUE";
    }
    if (Array.isArray(value)) {
        return value.some((option) => option === "OTHER_VALUE");
    }
    return false;
};
exports.hasOtherValue = hasOtherValue;
/**
 * Validator for field metadata description when OTHER_VALUE is selected
 */
const requiredDescriptionForOtherValue = (field, records, record) => {
    const validator = (value, fieldsMetadata) => {
        var _a;
        const otherOptionEnabled = (_a = field.params.other_option) !== null && _a !== void 0 ? _a : false;
        if (!otherOptionEnabled || !record || !(0, exports.hasOtherValue)(value)) {
            return null;
        }
        const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
        const fieldMetadata = fieldLogic.getFieldMetadata(field, record, fieldsMetadata);
        if (!fieldMetadata || !fieldLogic.isFieldMetadataValid(fieldMetadata)) {
            return { requiredDescriptionForOtherValue: true };
        }
        return null;
    };
    return {
        validator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, {
            fieldLabel: (0, intl_1.$t)(texts_1.validationText.description),
        }),
    };
};
exports.requiredDescriptionForOtherValue = requiredDescriptionForOtherValue;
const required = (field) => {
    const isRequired = (0, fields_1.getFieldParamValue)(field, "required");
    return {
        validator: isRequired ? exports.requiredValidator : exports.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.is_required, { fieldLabel: field.label }),
    };
};
exports.required = required;
